module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("./img/logo.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-76be5584"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/loginGroup/logo_head.vue
// module id = 1267
// module chunks = 1